"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphalendMarketsQuery = void 0;
exports.alphalendMarketsQuery = `
query GetAllMarkets {
    allMarkets {
        marketId,
        coinType,
        price,
    }
}`;
//# sourceMappingURL=markets.js.map